<template>
    <q-dialog :value="dialogFiltersMobile"
              @hide="closeDialogFiltersMobile"
              transition-show="slide-up"
              transition-hide="slide-down"
              :maximized="maximizedToggle">
        <q-card class="modal-filters">
            <div class="modal-header">
                <span class="modal-title">Фильтры</span>
                <div class="modal-close" @click="closeDialogFiltersMobile">
                        <span aria-hidden="true">
                            <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M10.0845 8.49881L16.7752 1.80811C17.0749 1.5084 17.0749 1.02253 16.7752 0.722826C16.4755 0.42312 15.9896 0.42312 15.6899 0.722826L8.99924 7.41353L2.30854 0.723849C2.00883 0.424143 1.52296 0.424143 1.22325 0.723849C0.923548 1.02356 0.923548 1.50943 1.22325 1.80913L7.91396 8.49984L1.22428 15.1895C0.924571 15.4892 0.924571 15.9751 1.22428 16.2748C1.37464 16.4241 1.57001 16.4998 1.76641 16.4998C1.9628 16.4998 2.1592 16.4252 2.30854 16.2748L8.99924 9.5841L15.6899 16.2748C15.8403 16.4241 16.0357 16.4998 16.2321 16.4998C16.4285 16.4998 16.6249 16.4252 16.7742 16.2748C17.0739 15.9751 17.0739 15.4892 16.7742 15.1895L10.0845 8.49881Z" fill="white"/>
                            </svg>
                        </span>
                </div>
            </div>
            <q-card-section class="modal-content">
                <div id="filter-sort"
                     class="filter"
                     :class="{ active: hasSelected('sort'), show: isActive('sort')  }">
                    <button class="filter-toggle"
                            type="button"
                            aria-haspopup="true"
                            data-boundary="filter-sort"
                            @click.prevent="openDialogFilterMobile('sort')">
                        <span class="filter-name">
                            Сортировка
                            <span class="filter-count">{{ selectedSort() }}</span>
                        </span>
                        <span v-if="hasSelected('sort')" class="filter-clear" @click.stop="setSortOption(-1)">сбросить</span>
                        <span class="filter-arrow">
                            <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="64px" height="64px"
                                 viewBox="0 0 64 64" enable-background="new 0 0 64 64">
                                <polygon fill=""
                                         points="36.238,44.061 24.271,32.226 36.156,20.115 37.996,21.918 27.907,32.199 38.05,42.229"></polygon>
                            </svg>
                        </span>
                    </button>
                </div>
                <div v-for="filter in filterList"
                     v-if="hasFilterValues(filter.slug) && filter.slug !== 'category'"
                     class="filter"
                     :class="{ active: hasSelected(filter.slug), show: isActive(filter.slug)  }"
                     :id="'filter-' + filter.slug"
                     @click.prevent="openDialogFilterMobile(filter.slug)">
                    <button class="filter-toggle"
                            type="button"
                            :data-boundary="'filter-' + filter.slug">
                        <span class="filter-name">
                            {{ filter.name }}
                        </span>
                        <span class="filter-count">{{ selectedFilters(filter.slug) }}</span>
                        <span v-if="hasSelected(filter.slug)" class="filter-clear" @click.prevent.stop="clearFilterSelection(filter.slug)">сбросить</span>
                        <span class="filter-arrow">
                                <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="64px" height="64px"
                                     viewBox="0 0 64 64" enable-background="new 0 0 64 64">
                                    <polygon fill=""
                                             points="36.238,44.061 24.271,32.226 36.156,20.115 37.996,21.918 27.907,32.199 38.05,42.229"></polygon>
                                </svg>
                            </span>
                    </button>
                </div>
                <q-dialog :value="dialogFilterMobile"
                          transition-show="slide-up"
                          transition-hide="slide-down"
                          :maximized="maximizedToggle"
                          :content-class="classes">
                    <q-card class="modal-filters">
                        <div class="modal-header">
                            <span class="modal-title">{{ active === "sort" ? "Сортировка" : selectedFilterMobileTitle }}</span>
                            <div class="modal-close" @click="closeDialogFilterMobile">
                                <span aria-hidden="true">
                                    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M10.0845 8.49881L16.7752 1.80811C17.0749 1.5084 17.0749 1.02253 16.7752 0.722826C16.4755 0.42312 15.9896 0.42312 15.6899 0.722826L8.99924 7.41353L2.30854 0.723849C2.00883 0.424143 1.52296 0.424143 1.22325 0.723849C0.923548 1.02356 0.923548 1.50943 1.22325 1.80913L7.91396 8.49984L1.22428 15.1895C0.924571 15.4892 0.924571 15.9751 1.22428 16.2748C1.37464 16.4241 1.57001 16.4998 1.76641 16.4998C1.9628 16.4998 2.1592 16.4252 2.30854 16.2748L8.99924 9.5841L15.6899 16.2748C15.8403 16.4241 16.0357 16.4998 16.2321 16.4998C16.4285 16.4998 16.6249 16.4252 16.7742 16.2748C17.0739 15.9751 17.0739 15.4892 16.7742 15.1895L10.0845 8.49881Z" fill="white"/>
                                    </svg>
                                </span>
                            </div>
                        </div>
                        <q-card-section class="modal-content">
                            <div class="filter" v-if="isActive('sort')">
                                <div class="filter-menu" aria-labelledby="filter-sort">
                                    <div class="filter-menu-list">
                                        <div v-for="({ label, sort, dir, icon }, index) in sortOptions"
                                             class="filter-item">
                                            <div class="checkbox" @click.prevent="setSortOption(index)">
                                                <input :id="'sort-' + index" name="sort" type="radio"
                                                       :value="{ sort: sort, dir: dir }"
                                                       :checked="selected.sort === sort && selected.dir === dir">
                                                <label :for="'sort-' + index">
                                                    <span class="filter-item-title">{{ label }}</span>
                                                    <q-icon v-if="icon" :name="icon" />
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <filter-item
                                v-for="(filter, index) in selectedFilterMobile"
                                :key="`filter-item-${index}`"
                                :filter="filter"
                            ></filter-item>
                        </q-card-section>
                        <q-card-actions class="q-pa-md">
                            <div class="col-6 pr-2">
                                <q-btn label="Сбросить"
                                       color="primary"
                                       outline
                                       class="full-width"
                                       @click="clearFilterSelected(selectedFilterMobile[0].slug)" />
                            </div>
                            <div class="col-6 pl-2">
                                <q-btn @click="apply"
                                       label="Применить"
                                       color="primary"
                                       v-close-popup
                                       class="full-width"/>
                            </div>
                        </q-card-actions>
                    </q-card>
                </q-dialog>
            </q-card-section>

            <q-card-actions class="q-pa-md">
                <div class="col-6 pr-2">
                    <q-btn label="Сбросить"
                           color="primary"
                           outline
                           class="full-width"
                           @click="clearAllFilterSelection" />
                </div>
                <div class="col-6 pl-2">
                    <q-btn label="Показать"
                           color="primary"
                           class="full-width"
                           @click="closeDialogFiltersMobile" />
                </div>
            </q-card-actions>
        </q-card>
    </q-dialog>
</template>

<script>
import FilterItem from "./../../Catalog/Filter/Item"
import {mapActions, mapGetters, mapMutations, mapState} from "vuex";

export default {
    name: "Filters",
    components: {
        FilterItem,
    },
    props: [
        'classes'
    ],
    data() {
        return {
            maximizedToggle: true,
            selectedFilterMobile: false,
            selectedFilterMobileTitle: "",
        }
    },
    computed: {
        ...mapState('catalog', [
            'active',
            'selected',
            'filterList',
            'sortOptions',
            'dialogFiltersMobile',
            'dialogFilterMobile'
        ]),
        ...mapGetters('catalog', [
            'isActive',
            'filterValues',
            'hasFilterValues',
            'isSlider',
        ]),
    },
    methods: {
        ...mapActions('catalog', [
            'applyFilters',
            'clearFilterSelection',
            'clearAllFilterSelection',
        ]),
        ...mapMutations('catalog', [
            'setSortOption',
            'toggleDialogFiltersMobile',
            'toggleDialogFilterMobile',
            'setActive',
        ]),
        clearFilterSelected(filter) {
            Vue.delete(this.selected, filter);
        },
        selectedFilters(filter) {
            let str = ''

            if (this.selected[filter]) {
                const fields = this.filterValues(filter)
                const selectedFilters = this.selected[filter]

                if (Array.isArray(selectedFilters)) {
                    str = []
                    selectedFilters.forEach((el) => {
                        let res = _.find(fields, {'value': el.value ? el.value : _.toString(el)})

                        if (res) {
                            str.push(res.name)
                        }
                    });
                    str = str.join(', ')
                } else {
                    str = selectedFilters.min
                        + ((selectedFilters.min != selectedFilters.max) ? ` - ${selectedFilters.max}` : '')
                        + (selectedFilters.appendix ? ` ${selectedFilters.appendix}` : '')
                }
            }

            return str
        },
        openDialogFiltersMobile() {
            this.toggleDialogFiltersMobile(true)
        },
        closeDialogFiltersMobile() {
            this.toggleDialogFiltersMobile(false)
        },
        openDialogFilterMobile(filter) {
            this.setActive(filter)

            if (!(filter === 'sort')) {
                this.selectedFilterMobile = _.filter(this.filterList, function (f) {
                    if (f.slug === filter) {
                        return true;
                    }
                });
                this.selectedFilterMobileTitle = this.selectedFilterMobile[0]["name"]
            }
            this.toggleDialogFilterMobile(true)
        },
        closeDialogFilterMobile() {
            this.toggleDialogFilterMobile(false)
        },
        apply() {
            this.applyFilters()
            this.toggleDialogFilterMobile(false)
        },
        hasSelected(filter) {
            return this.selected[filter] && !_.isEmpty(this.selected[filter]);
        },
        selectedSort() {
            const dir = this.selected.dir
            const sort = this.selected.sort
            const res = _.find(this.sortOptions, {'sort': sort, 'dir': dir})
            if (res) return res.label;
        },
    }
}
</script>

<style scoped>
.q-btn--rectangle {
    border-radius: 3px;
}
</style>
